import { userDate, getHours } from 'owa-datetime';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc, { type LocalizedString } from 'owa-localize';
import {
    inboxBriefingMorningCommandText,
    inboxBriefingEveningCommandText,
} from './inboxBriefingsUtils.locstring.json';

/**
 * Checks if current time is within the morning briefing window (6am-11am).
 * @returns true if current hour is between 6 and 11 (inclusive)
 */
export function isMorningBriefing(): boolean {
    const now = userDate();
    const hour = getHours(now);
    return hour >= 6 && hour <= 11;
}

/**
 * Checks if current time is within the evening briefing window (5pm-10pm).
 * @returns true if current hour is between 17 and 21 (inclusive)
 */
export function isEveningBriefing(): boolean {
    const now = userDate();
    const hour = getHours(now);
    return hour >= 17 && hour <= 21;
}

/**
 * Checks if the inbox briefing SUA should be shown based on feature flight and current time.
 * @returns true if inbox briefing should be displayed
 */
export function shouldShowInboxBriefingSUA(): boolean {
    return (
        isFeatureEnabled('mon-copilot-inbox-briefings') &&
        (isMorningBriefing() || isEveningBriefing())
    );
}

/**
 * Helper function to determine which inbox briefing command to use based on current time
 */
export function getInboxBriefingCommandText(): LocalizedString {
    // Default to morning briefing for any other time
    return isEveningBriefing()
        ? loc(inboxBriefingEveningCommandText)
        : loc(inboxBriefingMorningCommandText);
}

/**
 * Helper function to determine which inbox briefing CMMID to use based on current time
 */
export function getCMMIDForInboxBriefing(): string {
    // Default to morning briefing CMMID for any other time
    return isEveningBriefing() ? 'cmmtw8e0u46' : 'cmmuwjzeuoy';
}
